import { ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PatientSocialHistoryEntry } from '@models/patient';
import { ExternalPrescription } from '@models/prescriptions/external-prescription';
import { Prescription } from '@models/prescriptions/prescription';
import { ActionPanelService } from '@services/actionpanel.service';
import { PatientService } from '@services/patient.service';
import { UsersService } from '@services/users.service';

@Component({
  selector: 'app-social-history',
  templateUrl: './social-history.component.html',
  styleUrls: ['./social-history.component.less'],
})
export class SocialHistoryComponent implements OnInit, OnChanges {
  public prescriptionList: Prescription[];
  socialHistoryEntry: PatientSocialHistoryEntry;
  public externalPrescriptionEntry: ExternalPrescription;
  @Input() panelHeight: number;
  @Input() patientId: number;

  constructor(
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private actionPanelService: ActionPanelService,
    private patientService: PatientService,
    private userService: UsersService,
  ) {}

  ngOnInit() {
    if (!this.patientId) {
      this.patientId = +this.route.snapshot.params.patId.split('_')[0];
    }
    this.getPatientHistory();
  }

  ngOnChanges() {
    this.getPatientHistory();
  }

  public getPatientHistory(){
    if (!this.patientId) return;
    
    this.patientService.getSocialHistoryByPatientId(this.patientId).subscribe((res) => {
      if (res) {
        this.socialHistoryEntry = res;
      } else {
        this.socialHistoryEntry = {
          id: 0,
          entryDate: new Date(),
          enteredByUserId: this.userService.loggedInUser.id,
          entryText: '',
          patientId: this.patientId,
        };
      }
    });
  }

  public saveSocialHistoryElement(event: string) {
    this.socialHistoryEntry.entryText = event;
    if (this.socialHistoryEntry.id) {
      this.patientService.updateSocialHistory(this.socialHistoryEntry).subscribe();
    } else {
      this.patientService.createSocialHistory(this.socialHistoryEntry).subscribe();
    }
  }
}
